enum InsuranceDisplayStatus {
  ACCEPT_ONLY = 'ACCEPT_ONLY',
  ACTIVE_ONLY = 'ACTIVE_ONLY',
  ACTIVE_WITH_RENEWAL = 'ACTIVE_WITH_RENEWAL',
}

export default InsuranceDisplayStatus;
